import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TESTComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  
    
  
  
  }

}



  